import { Component, Inject, OnInit, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {
  MSAL_GUARD_CONFIG,
  MsalBroadcastService,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionType,
  PopupRequest
} from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { ApplicationState } from '../../../../shared/state/application-state.service';

@Component({
    selector: 'app-login',
    imports: [RouterLink],
    templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  private readonly _destroying$ = new Subject<void>();

  authService = inject(MsalService);
  broadcastService = inject(MsalBroadcastService);
  router = inject(Router);
  applicationStateService = inject(ApplicationState);

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
  ) {}

  ngOnInit(): void {
  }

  login() {
    if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.applicationStateService.loadUserData();
            this.navigateToHome();
          });
      } else {
        this.authService
          .loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.applicationStateService.loadUserData();
            this.navigateToHome();
          });
      }
    } else {
      if (this.msalGuardConfig.authRequest) {
        this.authService
          .loginPopup({
            ...this.msalGuardConfig.authRequest,
          } as PopupRequest)
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.applicationStateService.loadUserData();
            this.navigateToHome();
          });
      } else {
        this.authService
          .loginPopup()
          .subscribe((response: AuthenticationResult) => {
            this.authService.instance.setActiveAccount(response.account);
            this.applicationStateService.loadUserData();
            this.navigateToHome();
          });
      }
    }
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }
}
